<template>
  <Modal appear @close="close">
    <template slot="content">
      <div class="p-config-management-form">
        <div class="p-config-management-form__header">
          <h3 class="p-config-management-form__title">
            {{ params.name }}の権限を変更する
          </h3>
        </div>
        <div class="p-config-management-form__content">
          <div class="c-fieldset">
            <p class="c-fieldset__header">
              <span class="c-fieldset__title">権限</span>
              <span class="c-required">必須</span>
            </p>
            <div class="c-fieldset__content">
              <RadioGroupAuthority v-model="params.isAuthority" />
            </div>
          </div>
        </div>
        <div class="p-config-management-form__footer">
          <div class="c-alertPos">
            <Button
              variant="main"
              size="w230"
              fsize="f16"
              :disabled="isDisabled"
              :class="{ 'is-loading': isProcessing }"
              @click="submit"
            >
              変更する
            </Button>
            <Alert v-if="request.error" variant="center">
              {{ request.error }}
            </Alert>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Modal from '@/components/Modal';
import RadioGroupAuthority from '@/components/config/RadioGroupAuthority';
import apiOrganizations from '@/api/organizations';

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    Alert,
    Button,
    Modal,
    RadioGroupAuthority
  },
  data() {
    return {
      params: {
        mailAddress: this.item.mailAddress,
        name: this.item.name,
        isAuthority: this.item.isAuthority
      },
      request: {
        error: ''
      },
      isEdited: {
        isAuthority: false
      },
      isProcessing: false
    };
  },
  computed: {
    organization() {
      return this.$store.getters['view/organization'];
    },
    isDisabled() {
      return this.isProcessing || !this.isEdited.isAuthority;
    }
  },
  watch: {
    params: {
      handler() {
        // 何か入力したらサーバーからのエラーメッセージを消す
        this.request.error = '';
      },
      deep: true
    },
    'params.isAuthority': {
      handler(value, oldValue) {
        this.isEdited.isAuthority = value !== this.item.isAuthority;
      }
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    submit() {
      if (this.isDisabled) {
        return;
      }
      this.isProcessing = true;

      const method = this.params.isAuthority ? 'post' : 'delete';

      return apiOrganizations.users.permissions.organization[method](
        this.auth.idToken,
        this.organization.organizationId,
        this.item.userId
      )
        .then(response => {
          this.isProcessing = false;
          const item = Object.assign({}, this.item);
          item.isAuthority = this.params.isAuthority;
          this.$emit('edit', item);
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.request.error = error.response.data.errors[0].userMessage;
          }
          this.isProcessing = false;
        });
    }
  }
};
</script>
